import { render, staticRenderFns } from "./StackedVirtualSidebarContainer.vue?vue&type=template&id=12d8e531&scoped=true"
import script from "./StackedVirtualSidebarContainer.vue?vue&type=script&lang=ts"
export * from "./StackedVirtualSidebarContainer.vue?vue&type=script&lang=ts"
import style0 from "./StackedVirtualSidebarContainer.vue?vue&type=style&index=0&id=12d8e531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8e531",
  null
  
)

export default component.exports